import _ from 'lodash';

import buildFilterOptions from '@/components/vehicle-detail-header-filter/utils/build-filter-options';
import { DEFAULT_ATTRIBUTE } from '@/components/vehicle-detail-header-filter/utils/constants';

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'variants' implicitly has an 'any' type.
const getNextFilterAttribute = (variants, attributes, OPTIONS_LIMIT) => {
  const filterableAttributes = _.filter(attributes, (attribute) => {
    const optionsForAttribute = buildFilterOptions(variants, attribute, true);
    return (
      _.size(optionsForAttribute) < OPTIONS_LIMIT &&
      _.size(optionsForAttribute) > 1 &&
      _.every(optionsForAttribute, 'value')
    );
  });

  const nextFilterAttribute = _.isEmpty(filterableAttributes)
    ? DEFAULT_ATTRIBUTE
    : _.minBy(filterableAttributes, ({ preference }) => preference);
  return nextFilterAttribute;
};

export default getNextFilterAttribute;
